import { render, staticRenderFns } from "./GSLogout.vue?vue&type=template&id=8d7364a6&"
import script from "./GSLogout.vue?vue&type=script&lang=js&"
export * from "./GSLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports